import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { IDeliveriesState } from '../deliveries-state';
import { filter, mergeMap, withLatestFrom } from 'rxjs';
import { PREFERENCE_LOCATION_SET, ROUTER_NAVIGATION } from '@core/state/action-types';
import { getRouterState } from '@core/state/router/router-selectors';
import { getPreference } from '@core/state/preference/preference-selectors';
import { isNullOrUndefined } from '@core/utils/object';
import { IAppRouterState } from '@core/state/router/router-state';
import { SessionPreference } from '@core/models/preference/session-preference';
import {
    DELIVERIES_SETTINGS_USERS,
    DELIVERIES_SETTINGS_MYDRIVERS,
    DELIVERIES_SETTINGS_MYDRIVERS_CREATE
} from '@core/router/app-states';
import { FetchUsersAction } from '@core/state/users/users-actions';
import { FetchDriversAction } from '@core/state/drivers/drivers-actions';
import { RouterNavigationCancelAction } from '@core/state/router/router-actions';
import { RouterGoAction } from '@core/state/router/router-actions';

@Injectable()
export class DeliveriesSettingsEffects {
    constructor(
        private actions$: Actions,
        private store$: Store<IDeliveriesState>
    ) {}

    routerDeliverySettings$ = createEffect(() => this.actions$.pipe(
        ofType(ROUTER_NAVIGATION, PREFERENCE_LOCATION_SET),
        withLatestFrom(
            this.store$.select(getRouterState),
            this.store$.select(getPreference)
        ),
        filter(
            ([action, routerState, sessionPreference]) =>
                !isNullOrUndefined(sessionPreference?.location)
        ),
        mergeMap(([action, routerState, sessionPreference]: 
            [Action, IAppRouterState, SessionPreference]) => {
            const { name: stateName, fromState, params } = routerState;
                const actions: Action[] = [];
                const isNavigation: boolean = action.type === ROUTER_NAVIGATION;

                if (stateName === DELIVERIES_SETTINGS_MYDRIVERS) {
                    if (isNavigation  || (
                        !isNavigation && !!sessionPreference?.previousLocation && sessionPreference.previousLocation?.id !== (action as any).payload?.location?.id
                    )) {

                        actions.push(new FetchDriversAction({
                            locationId: sessionPreference.location.id
                        }))
                    }

                } else if (stateName === DELIVERIES_SETTINGS_MYDRIVERS_CREATE) {
                    if (fromState.name.indexOf(DELIVERIES_SETTINGS_MYDRIVERS) !== 0) {

                        actions.push(new RouterNavigationCancelAction({ state: DELIVERIES_SETTINGS_MYDRIVERS_CREATE}));
                        actions.push(new RouterGoAction({ name: DELIVERIES_SETTINGS_MYDRIVERS }));
                    }
                } else if (stateName === DELIVERIES_SETTINGS_USERS) {
                    if ((isNavigation && fromState.name.indexOf(DELIVERIES_SETTINGS_USERS) !== 0) || (
                        !isNavigation && sessionPreference.previousLocation?.id !== (action as any).payload?.location?.id
                    )) {

                        actions.push(new FetchUsersAction({
                            locationId: sessionPreference.location.id
                        }))
                    }
                }

            return actions;
        })
    ));
}
